import tachoSagas from '../sagas/tachoSagas';

const sagas = [...tachoSagas];

export default sagas;
